import numeral from "numeral";

export default (number, format) => numeral(number).format(format);
